/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Faint_Goose_HowlInputs */

const en_happy_faint_goose_howl = /** @type {(inputs: Happy_Faint_Goose_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed`)
};

const de_happy_faint_goose_howl = /** @type {(inputs: Happy_Faint_Goose_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert`)
};

/**
* | output |
* | --- |
* | "Changed" |
*
* @param {Happy_Faint_Goose_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_faint_goose_howl = /** @type {((inputs?: Happy_Faint_Goose_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Faint_Goose_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_faint_goose_howl(inputs)
	return de_happy_faint_goose_howl(inputs)
});